module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-03.a4adb6b1.jpg";